import React from 'react';
import { BreakpointSizeType } from '../../../theme/type/breakpoints-type';

interface IResponsiveProps {
    breakpoint: BreakpointSizeType;
    children: React.ReactElement;
    type?: 'max' | 'min';
}

export const Responsive: React.FC<IResponsiveProps> = ({
    children,
    breakpoint,
    type = 'min',
    ...props
}: IResponsiveProps) => {
    const visibilityClassByBreakpointMin: Record<BreakpointSizeType, string> = {
        xs: 'hidden xs:block',
        vs: 'hidden vs:block',
        sm: 'hidden sm:block',
        md: 'hidden md:block',
        lg: 'hidden lg:block',
        vl: 'hidden vl:block',
        xl: 'hidden xl:block',
        xxl: 'hidden xxl:block',
        fullhd: 'hidden fullhd:block',
    };

    const visibilityClassByBreakpointMax: Record<BreakpointSizeType, string> = {
        xs: 'block xs:hidden',
        vs: 'block vs:hidden',
        sm: 'block sm:hidden',
        md: 'block md:hidden',
        lg: 'block lg:hidden',
        vl: 'block vl:hidden',
        xl: 'block xl:hidden',
        xxl: 'block xxl:hidden',
        fullhd: 'block fullhd:hidden',
    };

    const visibilityClass =
        type === 'min' ? visibilityClassByBreakpointMin[breakpoint] : visibilityClassByBreakpointMax[breakpoint];

    return <div className={visibilityClass}>{React.cloneElement(children, { ...props })}</div>;
};
